import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { isPrerender } from '../utils/isPrerender';
import Seo from './Seo';
import InfoPratique from './InfoPratique';
import PresentationClub from './PresentationClub';
import SocialWall from './SocialWall';
import Partenaires from './Partenaires';
import ProchainsMatch from './ProchainsMatchs';

function Home() {
  const [isCoverLoaded, setIsCoverLoaded] = useState(false);
  const coverRef = useRef(null);
  const heroRef = useRef(null);

  useEffect(() => {
    // Si l'image est déjà en cache (chargée avant l'hydratation), onLoad ne se
    // déclenchera pas : on rattrape le cas ici.
    if (coverRef.current && coverRef.current.complete) setIsCoverLoaded(true);
  }, []);

  // Parallaxe : l'image du hero défile plus lentement que la page.
  useEffect(() => {
    if (isPrerender()) return;
    const hero = heroRef.current;
    if (!hero) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    let raf = 0;
    const update = () => {
      raf = 0;
      const offset = Math.min(window.scrollY, hero.offsetHeight) * 0.3;
      hero.style.setProperty('--parallax', offset.toFixed(1));
    };
    const onScroll = () => {
      if (!raf) raf = requestAnimationFrame(update);
    };

    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <div>
      <Seo
        path="/"
        description="Rejoignez le Tennis de Table de Briançon, club dynamique au cœur des Alpes : créneaux de jeu libres pour tous les niveaux, compétitions FFTT et informations pratiques."
      />

      <div
        ref={heroRef}
        className={`container-cover ${isCoverLoaded ? 'is-loaded' : ''}`}
      >
        <img
          ref={coverRef}
          src="/img/cover-1280.webp"
          srcSet="/img/cover-640.webp 640w, /img/cover-1280.webp 1280w, /img/cover-1920.webp 1920w"
          sizes="100vw"
          alt="Table de tennis de table face aux fenêtres du gymnase, avec vue sur la vieille ville de Briançon"
          className="cover-image"
          width="1920"
          height="1080"
          fetchPriority="high"
          decoding="async"
          onLoad={() => setIsCoverLoaded(true)}
        />
        <div className="cover-txt">
          <h1>Vous souhaitez rejoindre le club du TTBriançon ?</h1>
          <Link className="btn btn-primary" to="/contact">
            Contactez-nous
          </Link>
        </div>
      </div>
      <PresentationClub />
      <InfoPratique />
      <ProchainsMatch />
      <SocialWall />
      <Partenaires />
    </div>
  );
}

export default Home;
